import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { currencyStatement } from "../../../api/data";
import CoinTypeOptions from "../../../components/serverList/coinTypeOptions.vue";
import serverList from "../../../components/serverList/serverOptions.vue";
import vipOptions from "../../../components/serverList/vipOptions.vue";
import VxeTable from "@/components/vxeTable/vxeTable.vue";
import { getGameCoinMap } from "@/utils/dictionary";
import timeDateOptions from "../../../components/timeList/timeDateOptions.vue";
export default {
  components: {
    serverList: serverList,
    vipOptions: vipOptions,
    CoinTypeOptions: CoinTypeOptions,
    timeDateOptions: timeDateOptions,
    VxeTable: VxeTable
  },
  name: "currencyAnalysis",
  data: function data() {
    var _this = this;
    var h = this.$createElement;
    return {
      coinList: {},
      coinTypeLists: [],
      options: [{
        value: 0,
        label: "全部"
      }, {
        value: 1,
        label: "产出"
      }, {
        value: 2,
        label: "消耗"
      }],
      searchInfo: {
        server_id: [],
        vip_levels: [],
        statement_type: "",
        coin_type: []
      },
      timedata: [this.$moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:59:59")],
      tableData: [],
      tableDataCount: {},
      tableColumn: [{
        field: "date_str",
        title: "日期",
        sortable: true
      }, {
        field: "server_id",
        title: "服务器id",
        sortable: true
      }, {
        field: "role_vip_level",
        title: "vip等级",
        sortable: true
      }, {
        field: "statement_type",
        title: "流水类型",
        sortable: true,
        slots: {
          default: function _default(_ref) {
            var row = _ref.row;
            return [h("span", [_this.coinList[row.coin_type]])];
          }
        }
      }, {
        field: "coin_type",
        title: "操作类型",
        sortable: true,
        slots: {
          default: function _default(_ref2) {
            var row = _ref2.row;
            return [h("span", [row.statement_type == 1 ? "产出" : "消耗"])];
          }
        }
      }, {
        field: "cnt",
        title: "流水总数",
        sortable: true
      }, {
        field: "percent",
        title: "[消耗/产出]占今日元宝的[消耗/产出]百分比",
        sortable: true
      }, {
        field: "day_count",
        title: "单日[消耗/产出]总量",
        sortable: true
      }, {
        field: "cnt_avg",
        title: "人均[消耗/产出]",
        sortable: true
      }, {
        field: "reason_name",
        title: "操作内容事件",
        sortable: true
      }, {
        field: "operation_role_cnt",
        title: "操作人数",
        sortable: true
      }, {
        field: "operation_cnt",
        title: "操作次数",
        sortable: true
      }]
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var index;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getGameCoinMap();
            case 2:
              _this2.coinList = _context.sent;
              for (index in _this2.coinList) {
                _this2.coinTypeLists.push({
                  id: index,
                  desc: _this2.coinList[index]
                });
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    queryEvent: function queryEvent() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.searchInfo.sdate = _this3.timedata[0];
              _this3.searchInfo.edate = _this3.timedata[1];
              _context2.next = 4;
              return currencyStatement(_this3.searchInfo);
            case 4:
              res = _context2.sent;
              if (!res.data.list || res.data.list.length == 0) {
                _this3.tableData = [];
                _this3.$message({
                  message: "暂无数据",
                  type: "warning"
                });
              } else {
                _this3.tableData = res.data.list;
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    openPop: function openPop() {
      this.$notify({
        title: "货币统计",
        dangerouslyUseHTMLString: true,
        message: "<div>（1）根据货币产出和消耗途径，统计当天的货币产出和消耗情况</div>" + "<div>（2）可以选择的查询条件包括日期范围（默认昨天）、货币类型（单选），更改类型（产出、消耗 | 单选）、vip等级（多选，默认全部）、服务器列表（多选，默认全部）</div>" + "<div>（3）显示数据包括（日期,操作内容，更改类型，操作人数，操作次数，元宝总数，人均消费，货币占比）</div>" + "<div>（4）操作内容对应游戏配置-》事件原因配置</div>",
        duration: 0
      });
    }
  }
};